import RequestStatus from './schema/RequestStatus';
import SmartDocStatusAndSuggestionStore from './schema/SmartDocStatusAndSuggestionStore';
import { createStore } from 'satcheljs';

const defaultSmartDocStatusAndSuggestionStore: SmartDocStatusAndSuggestionStore = {
    status: RequestStatus.NotInitiated,
    suggestions: [],
};

export const getStore = createStore<SmartDocStatusAndSuggestionStore>(
    'smartDocStatusAndSuggestionStore',
    defaultSmartDocStatusAndSuggestionStore
);

export default getStore;
